var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRocketFlying = function SvgRocketFlying(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.04468L14.0613 1.20468C12.9329 1.3301 11.8808 1.83583 11.078 2.63868L4.53998 9.17668L7.36664 12.0047L13.906 5.46668C14.7091 4.66407 15.2149 3.61185 15.34 2.48334L15.5 1.04468Z",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54001 9.17671L2.12534 8.37137C2.04448 8.34452 1.97183 8.29742 1.91432 8.23455C1.8568 8.17169 1.81633 8.09515 1.79675 8.01223C1.77717 7.9293 1.77914 7.84274 1.80246 7.76079C1.82579 7.67884 1.86969 7.60422 1.93001 7.54404L2.08467 7.38937C2.60991 6.86404 3.27106 6.49535 3.99403 6.32461C4.71701 6.15388 5.47325 6.18784 6.17801 6.42271L7.01467 6.70137L4.54001 9.17671Z",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54001 9.17671L2.12534 8.37137C2.04448 8.34452 1.97183 8.29742 1.91432 8.23455C1.8568 8.17169 1.81633 8.09515 1.79675 8.01223C1.77717 7.9293 1.77914 7.84274 1.80246 7.76079C1.82579 7.67884 1.86969 7.60422 1.93001 7.54404L2.08467 7.38937C2.60991 6.86404 3.27106 6.49535 3.99403 6.32461C4.71701 6.15388 5.47325 6.18784 6.17801 6.42271L7.01467 6.70137L4.54001 9.17671Z",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3667 12.0047L8.17203 14.4193C8.19889 14.5002 8.24599 14.5728 8.30885 14.6303C8.37172 14.6879 8.44825 14.7283 8.53118 14.7479C8.6141 14.7675 8.70066 14.7655 8.78261 14.7422C8.86456 14.7189 8.93918 14.675 8.99936 14.6147L9.1547 14.46C9.67992 13.9347 10.0485 13.2735 10.2191 12.5505C10.3897 11.8276 10.3556 11.0714 10.1207 10.3667L9.84336 9.53333L7.3667 12.0047Z",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3667 12.0047L8.17203 14.4193C8.19889 14.5002 8.24599 14.5728 8.30885 14.6303C8.37172 14.6879 8.44825 14.7283 8.53118 14.7479C8.6141 14.7675 8.70066 14.7655 8.78261 14.7422C8.86456 14.7189 8.93918 14.675 8.99936 14.6147L9.1547 14.46C9.67992 13.9347 10.0485 13.2735 10.2191 12.5505C10.3897 11.8276 10.3556 11.0714 10.1207 10.3667L9.84336 9.53333L7.3667 12.0047Z",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68598 12.3587C5.68624 12.5558 5.64756 12.7509 5.57216 12.9329C5.49677 13.1149 5.38615 13.2803 5.24665 13.4194C4.66132 14.0047 1.71332 14.8334 1.71332 14.8334C1.71332 14.8334 2.54198 11.8834 3.12732 11.3001C3.38445 11.0423 3.72668 10.8871 4.08998 10.8634",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocketFlying, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rocket-flying.68012392.svg";
export { ForwardRef as ReactComponent };